module.exports = __webpack_public_path__ + "static/media/YM73_3.8783cf7f.jpg";